<template>
  <v-app>
    <v-toolbar
      class="navbar"
      color="primary"
      dark
      app
      flat
      scrollOffScreen
      style="z-index: 1000"
      extended
    >
      <v-text-field
        color="white"
        dark
        type="search"
        prepend-inner-icon="search"
        ref="search"
        label="Search (press ` to quick focus)"
        single-line
        full-width
        v-model="keyword"
        hide-details
        clearable
      ></v-text-field>
      <v-progress-linear
        :active="loading"
        indeterminate
        style="position: absolute; width: 100%; bottom: -7px; margin: 0; left: 0"
        color="red accent-4"
      ></v-progress-linear>

      <template slot="extension">
        <v-chip @click="keyword += ` loc:san`">san</v-chip>
        <v-chip @click="keyword += ` loc:las`">las</v-chip>
        <v-chip @click="keyword += ` status:unlisted`">unlisted</v-chip>
        <v-chip @click="keyword += ` status:listed`">listed</v-chip>
      </template>
    </v-toolbar>
    <v-content id="dialog">
      <v-container class="r-container">
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<style>
html,
body {
  font-family: "Raleway", sans-serif !important;
}
@media screen and (max-width: 601px) {
  .r-container {
    padding: 0 !important;
  }
}
.navbar {
  z-index: 100 !important;
}
</style>

<script>
import { mapActions, mapState } from 'vuex';

const _ = require('lodash');

export default {
  name: 'App',
  data() {
    return {
      keyword: '',
    };
  },
  computed: {
    ...mapState(['loading']),
  },
  created() {
    const vm = this;
    this.debounceSearch = _.debounce(vm.runSearch, 600);
  },
  mounted() {
    const vm = this;
    document.addEventListener('keyup', (e) => {
      if (e.key === '`') {
        vm.$refs.search.focus();
      }
    });
  },
  watch: {
    // eslint-disable-next-line
    keyword(val) {
      if (!val) {
        this.keyword = '';
      }
      this.debounceSearch();
    },
  },
  methods: {
    ...mapActions(['search']),
    runSearch() {
      this.search(this.keyword);
    },
  },
};
</script>
